import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Testimonial } from '../../models';
import { DataService, DocumentService } from '../../services';

@Component({
  selector: 'app-testimonials',
  templateUrl: './testimonials.component.html',
  styleUrls: ['./testimonials.component.scss']
})

export class TestimonialsComponent implements OnInit {
  testimonials: Testimonial[];
  slickCarouselConfig: any;

  constructor(
    private dataService: DataService,
    private documentService: DocumentService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.slickCarouselConfig = {...this.documentService.getslickCarouselConfig(),
      autoplay: true,
      autoplaySpeed: 3000,
      infinite: true, 
      slidesToShow: 1, 
      slidesToScroll: 1 
    };
    this.testimonials = this.dataService.getLocalTestimonials();
  }
}
